var map = {
	"./17.svg": "ff1d",
	"./18.svg": "d4e1",
	"./19.svg": "837c",
	"./21.svg": "2307",
	"./22.svg": "2d62",
	"./24.svg": "e609",
	"./26.svg": "caf8",
	"./27.svg": "7aff",
	"./3.svg": "e215",
	"./5.svg": "4dbf",
	"./7.svg": "7279"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "220b";